import { render } from "./addSubOrder.vue?vue&type=template&id=40ae58e3"
import script from "./addSubOrder.vue?vue&type=script&lang=js"
export * from "./addSubOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__